import Controller from '@ember/controller';
import moment from 'moment-timezone';

import { action, computed, set, get } from '@ember/object';

import { task, timeout } from 'ember-concurrency';

import { inject as iService } from '@ember/service';

import { inject as iController } from '@ember/controller';

import getConfig from 'beebee-base/lib/get-config';
import { beebeeAjaxGet } from 'beebee-base/lib/utility';
import { beebeeAjaxPost } from 'beebee-base/lib/utility/ajax';

export default class SkiInstructorController extends Controller {
  @iService notify;
  @iService intl;
  @iService session;
  @iService store;
  @iService router;

  @iController('application') applicationController;
  @iService log;

  @(task(function* (lang = null) {
    yield timeout(250);

    try {
      const instructor = yield beebeeAjaxGet(
        `${getConfig(this).APP.urlApi}/ecommerce_maestro_detail/${this.instructor_id}`
      );

      if (!instructor || !instructor.id) {
        this.router.transitionTo('index');
        return;
      }

      set(this, 'instructor', instructor);
    } catch (error) {
      this.router.transitionTo('index');
    }
  }).restartable())
  loadInstructorTask;

  @computed('instructor.id', 'this.session.openOrganization.id')
  get showSkeleton() {
    const { applicationController } = this;
    const { open_organization } = applicationController?.content || {};

    return !open_organization?.get('id') || !this.instructor?.id;
  }

  @computed('this.session.openOrganization.thumbnail_url', 'urlData')
  get thumbnail_url() {
    if (get(this, 'session.openOrganization.thumbnail_url')) {
      return `${this.urlData}/${get(this, 'session.openOrganization.thumbnail_url')}-medium.jpeg`;
    }
    return 'https://beebeeassets.beebeeboard.com/assets/img/logo.png';
  }

  @computed(
    'applicationController.imgPrivate',
    'applicationController.imgCorsi',
    'instructor.thumbnail_url',
    'this.session.openOrganization.id'
  )
  get imgCopertina() {
    const { applicationController, instructor } = this;
    const { open_organization } = applicationController?.content || {};

    if (!open_organization?.get('id')) {
      return null;
    }

    if (instructor.thumbnail_url) {
      return `${applicationController.urlData}/${instructor.thumbnail_url}-large.jpeg`;
    }

    return applicationController.imgPrivate;
  }

  @(task(function* () {
    try {
      yield timeout(50);
      const self = this;
      const events = [];

      yield timeout(500);

      if (this.oreSelected.length > 0) {
        for (const e of this.oreSelected) {
          if (!e.n_pax) {
            set(e, 'n_pax', 1);
          }

          const start_date = moment(e.start_date).tz('Europe/Rome', true).format('YYYY-MM-DDTHH:mmZ');
          const end_date = moment(e.end_date).tz('Europe/Rome', true).format('YYYY-MM-DDTHH:mmZ');

          events.push({
            partecipanti: '1',
            fisso: false,
            maestro_id: this.instructor_id,
            comprensorio: this.buyMaestro.product.comprensorio,
            lingua: self.language || '',
            persone: e.n_pax,
            start_date,
            end_date,
          });
        }
      }

      const data = {
        products: [
          {
            thumbnail_url: 't',
            partecipanti: '1',
            name: 'Individuale',
            persone: 0,
            product_status_id: 92,
            id: this.buyMaestro.product.id,
            assicurazione: false,
            events: events,
            modules: [1],
          },
        ],
        access_token: self.session.token,
      };

      const prezzoAPI = yield beebeeAjaxPost(
        `${getConfig(this).APP.urlApi}/scuolasci_freeprice`,
        null,
        data
      );

      if (Array.isArray(prezzoAPI?.data?.products)) {
        const product = prezzoAPI.data.products[0];
        // products can be an empty array: product is then undefined and
        // product.events threw (twin of Sentry EMBER-SCUOLE-ECOMMERCE-2XK,
        // fixed in detail.js). Guard both hops.
        (product?.events || []).forEach((event) => {
          if (self.oreSelected.length > 0) {
            self.oreSelected.forEach((e) => {
              if (
                moment(e.start_date)
                  .tz('Europe/Rome', true)
                  .isSame(moment(event.start_date).tz('Europe/Rome'), 'minute')
              ) {
                set(e, 'price', event.prezzo);
              }
            });
          }
        });
      }

      set(this, 'oreSelected.prezzoAPI', prezzoAPI?.data);

      if (
        prezzoAPI.data.products &&
        prezzoAPI.data.products.some(
          (product) => product.product_status_id === 92 && product.maestro_diverso === true
        )
      ) {
        this.notify.warning(this.intl.t('We cannot guarantee the same teacher'));
        set(this, 'oreSelected', []);
        set(this, 'buyMaestro', null);
        return false;
      }

      return true;
    } catch (e) {
      // Left uncaught, a 4xx/network failure here surfaced as a Sentry
      // unhandled rejection. User-triggered (private price calc): notify.
      this.log.error('freePrivatePriceTask failed', e);
      const detail = e?.responseJSON?.errors?.[0]?.detail;
      this.notify.error(detail || this.intl.t('beebeeboard error'));
      return false;
    }
  }).restartable())
  freePrivatePriceTask;

  @(task(function* (dispo = null, individuali = false) {
    yield timeout(50);

    try {
      yield beebeeAjaxPost(
        `${getConfig(this).APP.urlApi}/ecommerce_check_product`,
        this.session.token,
        this.item.block_check_json
      );

      if (individuali) {
        this._addPrivateCart();
      }
    } catch (e) {
      this.log.error('ski-instructor: add private cart failed', e);
    }
  }).restartable())
  checkBlockTask;

  _addPrivateCart() {
    const bloccoOre = {
      maestro: this.buyMaestro,
      item: this.item,
      comprensorio: this.intComp || this.applicationController.location,
      language: this.intLang,
      gender: this.gender,
      prezzoAPI: this.oreSelected.prezzoAPI,
      ore: [],
    };

    for (let i = 0; i < this.oreSelected.length; i++) {
      bloccoOre.ore.push(this.oreSelected[i]);
    }

    this.applicationController.addCart('private', bloccoOre);
    set(this, 'buyMaestro', null);
  }

  @action
  addPrivateCart() {
    this._addPrivateCart();
  }

  get minPartecipanti() {
    return this.session.option_field?.ecommerce_private_min_max?.min || 1;
  }

  get maxPartecipanti() {
    return this.session.option_field?.ecommerce_private_min_max?.max || 10;
  }

  // Ported from detail controller: template referenced these string actions
  // but they were never defined here (clicks used to throw).
  @action
  addParPrivate() {
    for (let i = 0; i < this.oreSelected.length; i++) {
      if (this.oreSelected[i].n_pax) {
        set(this.oreSelected[i], 'n_pax', this.oreSelected[i].n_pax + 1);
      }

      if (!this.oreSelected[i].n_pax || this.oreSelected[i].n_pax > this.maxPartecipanti) {
        set(this.oreSelected[i], 'n_pax', this.maxPartecipanti);
      }
    }

    this.freePrivatePriceTask.perform();
  }

  @action
  delParPrivata() {
    for (let i = 0; i < this.oreSelected.length; i++) {
      if (this.oreSelected[i].n_pax) {
        set(this.oreSelected[i], 'n_pax', this.oreSelected[i].n_pax - 1);
      }

      if (!this.oreSelected[i].n_pax || this.oreSelected[i].n_pax < this.minPartecipanti) {
        set(this.oreSelected[i], 'n_pax', this.minPartecipanti);
      }
    }

    this.freePrivatePriceTask.perform();
  }

  @action
  selectProduct(product) {
    const { applicationController } = this;
    const { prodotti } = applicationController || {};
    const { products } = prodotti || {};

    let item = null;
    if (Array.isArray(products)) {
      item = products.find((i) => i.id === parseInt(product.id));
    }

    // Handle the product action
    set(this, 'buyMaestro', {
      product,
      id: this.instructor.id,
    });
    set(this, 'start_date', product.first_dispo);
    set(this, 'intComp', product.comprensorio);
    set(this, 'item', item);
  }
}
